import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';

import { TranslationKeyMap } from '../task/task.component.i18n';

@Component({
    selector: 'cmps-task-list-task-actions',
    templateUrl: './task-actions.component.html',
})
export class TaskActionsComponent implements OnDestroy {
    @Input() canEdit: boolean;
    @Input() editing: boolean;
    @Output() deleteClick: EventEmitter<void>;
    @Output() editClick: EventEmitter<void>;
    @Output() saveClick: EventEmitter<void>;
    @Output() cancelEditClick: EventEmitter<void>;

    /** @private */
    _i18n = TranslationKeyMap;

    constructor() {
        this.deleteClick = new EventEmitter();
        this.editClick = new EventEmitter();
        this.saveClick = new EventEmitter();
        this.cancelEditClick = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.deleteClick.complete();
        this.editClick.complete();
        this.saveClick.complete();
        this.cancelEditClick.complete();
    }
}
